import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import useAtlasTimeRange from '../agent-atlas/hooks/useAtlasTimeRange';
import AtlasTimeRangeScope from '../agent-atlas/hooks/AtlasTimeRangeScope';

function RollingWindow({ children }) {
  const { rangeKey, dateRange, days, setRange } = useAtlasTimeRange();
  const { start_time: start, end_time: end } = dateRange;
  const bounds = useMemo(() => (rangeKey === 'custom'
    ? { start_time: start, end_time: end }
    : { start_time: new Date(Date.parse(end) - days * 86_400_000).toISOString(), end_time: end }
  ), [rangeKey, start, end, days]);
  const dateParams = useMemo(() => ({ days, ...bounds }), [days, bounds]);
  return (
    <AtlasTimeRangeScope rangeKey={rangeKey} dateRange={bounds} setRange={setRange} dateParams={dateParams}>
      {children}
    </AtlasTimeRangeScope>
  );
}

// Above Routes so Dashboard's separate layout cannot reset the clock on the way to Conversations.
export default function CustomAgentsTimeRange({ children }) {
  const { pathname } = useLocation();
  const enabled = /^\/custom-agents\/(dashboard|conversations)\/?$/.test(pathname);
  return enabled ? <RollingWindow>{children}</RollingWindow> : children;
}
